<template>
  <div class="operation-overview-container">
    <div class="container-top">
      <div class="data-review">数据总览</div>
      <div class="school-select">
        <p class="school-name">{{ schoolSelectName || '- -' }}</p>
        <img
          class="switch-icon"
          src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202307/ddd303c5e801417d820d391216d4e848.png"
          alt="切换"
          @click="showSwitchSchoolDialog = true"
        />
      </div>
    </div>
    <div class="class-data-list">
      <ClassCard class="card-item" v-for="item in classDataList" :key="item.id" :cardData="item" />
    </div>
    <div class="chart-content">
      <div
        class="chart-item"
        :style="{
          width: `calc((100vw - 152px - 40px - 16px - 6px - ${scrollbarWidth}px) / 2)`
        }"
        v-for="(item, index) in chartDataList"
        :key="index"
      >
        <LiveRanking v-if="index === 1" :liveInfo="liveInfoList" />
        <ChartRender
          v-if="index !== 1 && termList.length"
          :chartData="item"
          :currentIndex="index"
          :termList="termList"
          :sourceTotal="sourceTotal"
          @changeTermData="handleChangeTermData"
        />
      </div>
    </div>

    <!-- 切换学校弹框 -->
    <SwitchSchool
      :switchingSchoolDialogFlag="showSwitchSchoolDialog"
      @handleSwitchingSchoolDialogClose="handleSwitchingSchoolDialogClose"
    />
  </div>
</template>

<script>
import SwitchSchool from '../../components/switchingSchool/index.vue'
import ClassCard from './components/ClassCard.vue'
import ChartRender from './components/ChartRender.vue'
import LiveRanking from './components/LiveRanking.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'OperationOverview',
  components: {
    SwitchSchool,
    ClassCard,
    ChartRender,
    LiveRanking
  },
  async created() {
    await this.getTermList()
    this.$once('hook:beforeDestroy', () => {
      this.timerIdInitData && clearInterval(this.timerIdInitData)
    })
    // this.timerIdInitData = setInterval(() => {
    // this.initChartsData()
    // }, 100000)
  },
  mounted() {
    this.setWidth()
  },
  data() {
    return {
      showSwitchSchoolDialog: false,
      timerIdInitData: null,
      termList: [],
      currentTermId: '',
      schoolCode: '',
      classDataList: [
        {
          id: 1,
          name: '教室总数',
          totalNum: 0,
          unit: '间',
          specailNum: '0',
          specailTitle: '应用率',
          color: '#688EE0',
          specailUnit: '%'
        },
        {
          id: 2,
          name: '教室直播',
          totalNum: 0,
          unit: '次',
          specailNum: '0',
          specailUnit: '次',
          specailTitle: '今日教室直播',
          color: '#9B93E9'
        },
        {
          id: 3,
          name: '累计上课老师',
          totalNum: 0,
          unit: '人',
          color: '#63AAC0',
          specailNum: '0',
          specailUnit: '人',
          specailTitle: '今日上课老师'
        }
      ],
      chartDataList: [
        // 教室启用情况
        {
          title: '教室启用情况',
          type: 'bar',
          chartOptions: {
            title: {
              text: '教室启用情况'
            },
            legend: {
              data: [
                {
                  name: '启用中',
                  itemStyle: {
                    color: '#5F60D3'
                  }
                },
                {
                  name: '未启用',
                  itemStyle: {
                    color: '#E1E5E9'
                  }
                }
              ]
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                // Use axis to trigger tooltip
                type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
              }
            },
            xAxis: {
              data: []
            },
            yAxis: {
              type: 'value',
              name: '间',
              nameTextStyle: {
                padding: [0, 0, -12, 12],
                color: '#999BA8'
              },
              min: 0,
              axisLine: {
                show: true,
                lineStyle: {
                  color: '#D4DAE3'
                }
              },
              axisLabel: {
                color: '#999BA8'
              },
              splitLine: {
                show: false
              },
              scale: true
            },
            series: [
              {
                name: '启用中',
                type: 'bar',
                stack: 'total',
                label: {
                  show: true
                },
                emphasis: {
                  focus: 'series'
                },
                itemStyle: {
                  color: '#5F60D3'
                },
                // barWidth: 26,
                barMaxWidth: 26,
                data: []
              },
              {
                name: '未启用',
                type: 'bar',
                stack: 'total',
                label: {
                  show: true
                },
                emphasis: {
                  focus: 'series'
                },
                itemStyle: {
                  color: '#E1E5E9'
                },
                // barWidth: 26,
                barMaxWidth: 26,
                data: []
              }
            ]
          }
        },
        // 教室直播排行
        {
          title: '教室直播排行',
          type: 'null'
        },
        // 教学直播趋势
        {
          title: '教学直播趋势',
          type: 'line',
          topData: [
            { title: '资源', number: 461100 },
            { title: '储存', number: 461100 }
          ],
          chartOptions: {
            title: {
              text: '教学直播趋势'
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'line'
              },
              formatter: function (a) {
                let str = ''
                let item = a[0]
                str = `${item.axisValue}<br />${item.marker}直播次数&emsp;${item.data}`
                return str
              }
            },
            xAxis: {
              data: []
            },
            yAxis: {
              type: 'value',
              name: '次',
              nameTextStyle: {
                padding: [0, 0, -12, 12],
                color: '#999BA8'
              },
              min: 0,
              axisLine: {
                show: true,
                lineStyle: {
                  color: '#D4DAE3'
                }
              },
              axisLabel: {
                color: '#999BA8'
              },
              splitLine: {
                show: false
              },
              scale: true
            },
            series: [
              {
                type: 'line',
                data: [],
                // symbol: 'circle',
                symbolSize: 6,
                symbolKeepAspect: true,
                areaStyle: {
                  color: '#5F60D3',
                  opacity: 0.3
                },
                itemStyle: {
                  color: '#5F60D3', // 改变折线点的颜色
                  borderColor: '#fff',
                  borderWidth: 1
                },
                lineStyle: {
                  color: '#5F60D3'
                  // shadowColor: '#F92564',
                  // shadowBlur: 15,
                  // shadowOffsetY: 11
                },
                areaStyle: {
                  // 教学资源统计图表
                  color: {
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      { offset: 0, color: 'rgba(95,96,211,0.4)' },
                      { offset: 0.7, color: 'rgba(95,96,211,0.1)' },
                      { offset: 1, color: 'transparent' }
                    ]
                  }
                }
              }
            ]
          }
        },
        // 录像资源统计
        {
          title: '录像资源统计',
          type: 'bar',
          chartOptions: {
            title: {
              text: '录像资源统计'
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'line'
              }
            },
            legend: {
              data: [
                {
                  name: '资源数量',
                  itemStyle: {
                    color: '#5BA2FF'
                  }
                },
                {
                  name: '录像存储',
                  itemStyle: {
                    color: '#6BCF7E'
                  }
                }
              ]
            },
            xAxis: {
              data: []
            },
            yAxis: [
              {
                type: 'value',
                name: '个',
                nameTextStyle: {
                  padding: [0, 0, -12, 12],
                  color: '#999BA8'
                },
                position: 'left',
                alignTicks: true,
                min: 0,
                // minInterval: 1,
                axisLine: {
                  show: true,
                  lineStyle: {
                    color: '#D4DAE3'
                  }
                },
                axisLabel: {
                  color: '#999BA8'
                },
                splitLine: {
                  show: false
                },
                scale: true
              },
              {
                type: 'value',
                name: 'G',
                nameTextStyle: {
                  padding: [0, 12, -12, 0],
                  color: '#999BA8'
                },
                position: 'right',
                alignTicks: true,
                min: 0,
                axisLine: {
                  show: true,
                  lineStyle: {
                    color: '#D4DAE3'
                  }
                },
                axisLabel: {
                  color: '#999BA8'
                },
                splitLine: {
                  show: false
                },
                scale: true
              }
            ],
            series: [
              {
                name: '资源数量',
                type: 'bar',
                barWidth: 16,
                barGap: 0,
                data: [],
                itemStyle: {
                  color: '#5BA2FF'
                }
              },
              {
                name: '录像存储',
                type: 'bar',
                barWidth: 16,
                yAxisIndex: 1,
                data: [],
                itemStyle: {
                  color: '#6BCF7E'
                }
              }
            ]
          }
        }
      ],
      liveInfoList: [],
      sourceTotal: {
        videoNum: 0,
        videoStorage: 0
      },
      scrollbarWidth: 0
    }
  },
  computed: {
    ...mapGetters('userInfo', ['userInfo']),
    ...mapGetters('switchingSchool', ['schoolSelect', 'schoolSelectName'])
    // isWin() {
    //   let platForm = window.navigator.platform
    //   console.log('platForm🐶:>>>>>>>', platForm, 'src/views/OperationOverview/index.vue')
    //   return platForm.indexOf('Win') > -1 ? true : false
    // }
  },
  watch: {
    schoolSelect: {
      handler: async function (newVal) {
        if (!newVal) return
        this.schoolCode = newVal
        this.initChartsData()
      },
      immediate: true
    }
  },
  methods: {
    handleSwitchingSchoolDialogClose() {
      this.showSwitchSchoolDialog = false
      //   this.initChartsData()
    },
    initChartsData() {
      Promise.all([
        this.getDataOverview(),
        this.getClassroomUseageData(),
        this.getLiveRankingList(),
        this.getTermLiveData(),
        this.getRecordData()
      ])
    },
    // 获取录像资源图表数据
    async getRecordData() {
      const res = await this.$http.getRecordSourceData({
        schoolCode: this.schoolCode
      })
      if (res.code === 200 && res.rt) {
        this.sourceTotal.videoNum = res.rt.videoCount
        this.sourceTotal.videoStorage = (res.rt.videoStorageCount / 1024).toPrecision(2) // 返回数据单位是GB，转换为TB
        let data = res.rt.recordDataInfos || []
        let weekList = []
        let videoNumList = []
        let videoStorageSizeList = []
        data.map((item, index) => {
          let weekNameItem = `第${item.week}周`
          weekList.push(weekNameItem)
          videoNumList.push(item.videoNum)
          videoStorageSizeList.push(item.videoStorageSize)
        })

        this.chartDataList[3].chartOptions.xAxis.data = weekList
        this.chartDataList[3].chartOptions.series[0].data = videoNumList
        this.chartDataList[3].chartOptions.series[1].data = videoStorageSizeList
      } else {
        this.$message.error(res.rt.resultMessage)
      }
    },
    // 获取学期信息
    async getTermList() {
      const termRes = await this.$http.getTermInfo()
      console.log('termRes', termRes)
      if (termRes.code !== 200) {
        return this.$message.warning('获取学期失败!')
      }
      if (termRes.code === 200 && termRes.rt) {
        this.termList = Object.keys(termRes.rt)
          .map((item) => {
            return {
              value: item,
              name: termRes.rt[item]
            }
          })
          .reverse()
        this.currentTermId = this.termList[0].value
      }
    },
    handleChangeTermData(key) {
      this.currentTermId = key
      this.getTermLiveData()
    },
    async getTermLiveData() {
      if (!this.currentTermId) {
        await this.getTermList()
      }
      const infoList = await this.$http.getTermLiveNum({
        schoolCode: this.schoolCode,
        termId: this.currentTermId
      })
      if (infoList.code === 200 && infoList.rt) {
        let weekArr = []
        let countArr = []
        let termLiveInfo = infoList.rt.termLiveInfoList || []
        termLiveInfo.map((item) => {
          let weekNameItem = `第${item.week}周`
          weekArr.push(weekNameItem)
          countArr.push(item.liveCount)
        })
        this.chartDataList[2].chartOptions.xAxis.data = weekArr
        this.chartDataList[2].chartOptions.series[0].data = countArr
      } else {
        this.$message.error(infoList.rt.resultMessage)
      }
    },
    // 数据总览
    async getDataOverview() {
      const dataRes = await this.$http.getDataOverview({
        schoolCode: this.schoolCode
      })
      if (dataRes.code === 200 && dataRes.rt) {
        this.classDataList[0].totalNum = dataRes.rt.classroomCount || 0
        this.classDataList[0].specailNum = dataRes.rt.inUseClassroomRate || 0
        this.classDataList[1].totalNum = dataRes.rt.liveCount || 0
        this.classDataList[1].specailNum = dataRes.rt.todayLiveCount || 0
        this.classDataList[2].totalNum = dataRes.rt.teacherCount || 0
        this.classDataList[2].specailNum = dataRes.rt.todayTeacherCount || 0
      } else {
        this.$message.error(dataRes.rt.resultMessage)
      }
    },
    // 教室启用情况
    async getClassroomUseageData() {
      const res = await this.$http.getClassroomUseage({
        schoolCode: this.schoolCode
      })
      if (res.code === 200 && res.rt) {
        let buildingNameArr = []
        let useCountArr = []
        let noUseCountArr = []
        let buildingData = res.rt || []
        buildingData.map((item) => {
          buildingNameArr.push(item.buildingName)
          useCountArr.push(item.inUseClassroomCount)
          noUseCountArr.push(item.notUseClassroomCount)
        })
        this.chartDataList[0].chartOptions.xAxis.data = buildingNameArr
        this.chartDataList[0].chartOptions.series[0].data = useCountArr
        this.chartDataList[0].chartOptions.series[1].data = noUseCountArr
      } else {
        this.$message.error(res.rt.resultMessage)
      }
    },
    // 直播排行
    async getLiveRankingList() {
      const res = await this.$http.getLiveRanking({
        schoolCode: this.schoolCode
      })
      if (res.code === 200 && res.rt) {
        this.liveInfoList = res.rt
      } else {
        this.$message.error(res.rt.resultMessage)
      }
    },
    getScrollbarWidth() {
      // Create a temporary div container and append it into the body
      const container = document.createElement('div')
      // Append the container in the body
      document.body.appendChild(container)
      // Force scrollbar on the container
      container.style.overflow = 'scroll'

      // Add ad fake div inside the container
      const inner = document.createElement('div')
      container.appendChild(inner)

      // Calculate the width based on the container width minus its child width
      const width = container.offsetWidth - inner.offsetWidth
      // Remove the container from the body
      document.body.removeChild(container)

      return width
    },
    setWidth() {
      this.scrollbarWidth = this.getScrollbarWidth()
      console.log('scrollbarWidth🐶:>>>>>>>', this.scrollbarWidth, 'src/views/OperationOverview/index.vue')
    }
  }
}
</script>

<style lang="scss" scoped>
$primary-color: #5f60d3;
:root {
  --scrollbar: 0px;
}
.operation-overview-container {
  width: 100%;
  min-height: calc(100vh - 96px);
  text-align: left;
}
.container-top {
  height: 20px;
  display: flex;
  align-items: center;
  color: #1e2228;
  .data-review {
    position: relative;
    font-size: 18px;
    padding-left: 21px;
    font-weight: 600;
    &::before {
      content: '';
      position: absolute;
      top: 4px;
      left: 0;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background: $primary-color;
    }
    &::after {
      content: '';
      position: absolute;
      top: 7px;
      left: 3px;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #fff;
    }
  }
  .school-select {
    margin-left: 16px;
    display: flex;
    align-items: center;
    font-size: 14px;
    .switch-icon {
      margin-left: 8px;
      width: 16px;
      height: 16px;
    }
  }
}
.class-data-list {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  width: calc(100% - 6px);
  .card-item {
    flex: 1;
    &:nth-child(1),
    &:nth-child(2) {
      margin-right: 16px;
    }
  }
}
.chart-content {
  margin-top: 16px;
  width: 100%;
  width: 100%;
  height: calc(100vh - 96px - 40px - 135px);
  display: flex;
  flex-wrap: wrap;
  //   justify-content: space-between;
  .chart-item {
    // width: calc((100vw - 152px - 40px - 16px) / 2 - 10px);
    height: calc(50% - 8px);
    min-height: 300px;
    background: #fff;
    &:nth-child(n) {
      margin-bottom: 16px;
    }
    &:nth-child(odd) {
      margin-right: 16px;
    }
  }
}
</style>
